// import Swiper JS
import Swiper from "swiper";
// core version + navigation, pagination modules:
import SwiperCore, {
    Scrollbar,
    Navigation,
    Pagination,
    Lazy,
} from "swiper/core";
// configure Swiper to use modules
SwiperCore.use([Scrollbar, Navigation, Pagination, Lazy]);

// import Swiper styles
import "swiper/swiper-bundle.css";

const swiper = $(window).on("load", function () {
    let swiper0Opts = {
        direction: "horizontal",
        lazy: true,
        preloadImages: false,
        autoHeight: false,
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next.swiper0",
            prevEl: ".swiper-button-prev.swiper0",
        },
        scrollbar: {
            el: ".swiper-scrollbar.swiper0",
            draggable: true,
        },
    };

    let swiper0 = new Swiper(".swiper-container.swiper0", swiper0Opts);

    let swiper1Opts = {
        spaceBetween: 1,
        slidesPerView: 1,
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 2,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
            },
        },
        centeredSlides: true,
        roundLengths: true,
        loop: true,
        loopAdditionalSlides: 30,
        navigation: {
            nextEl: ".swiper-button-next.swiper1",
            prevEl: ".swiper-button-prev.swiper1",
        },
    };

    let swiper1 = new Swiper(".swiper-container.swiper1", swiper1Opts);

    let swiper2Opts = {
        direction: "horizontal",
        lazy: true,
        preloadImages: true,
        autoHeight: true,
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next.swiper2",
            prevEl: ".swiper-button-prev.swiper2",
        },
        scrollbar: {
            el: ".swiper-scrollbar.swiper2",
            draggable: true,
        },
    };

    let swiper2 = new Swiper(".swiper-container.swiper2", swiper2Opts);

    let swiper2pOpts = {
        direction: "horizontal",
        lazy: true,
        preloadImages: true,
        autoHeight: true,
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next.swiper2p",
            prevEl: ".swiper-button-prev.swiper2p",
        },
        scrollbar: {
            el: ".swiper-scrollbar.swiper2p",
            draggable: true,
        },
    };

    let swiper2p = new Swiper(".swiper-container.swiper2p", swiper2pOpts);

    let swiper4Opts = {
        direction: "horizontal",
        lazy: true,
        preloadImages: true,
        observeParents: true,
        autoHeight: true,
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next.swiper4",
            prevEl: ".swiper-button-prev.swiper4",
        },
        scrollbar: {
            el: ".swiper-scrollbar.swiper4",
            draggable: true,
        },
    };

    let swiper4 = new Swiper(".swiper-container.swiper4", swiper4Opts);

    let swiper4mOpts = {
        direction: "horizontal",
        lazy: true,
        preloadImages: true,
        observeParents: true,
        autoHeight: true,
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 2,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next.swiper4mc",
            prevEl: ".swiper-button-prev.swiper4mc",
        },
        scrollbar: {
            el: ".swiper-scrollbar.swiper4mc",
            draggable: true,
        },
    };

    let swiper4m = new Swiper(".swiper-container.swiper4m", swiper4mOpts);

    let swiper5Opts = {
        direction: "horizontal",
        lazy: true,
        preloadImages: true,
        autoHeight: true,
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next.swiper5",
            prevEl: ".swiper-button-prev.swiper5",
        },
        scrollbar: {
            el: ".swiper-scrollbar.swiper5",
            draggable: true,
        },
    };

    let swiper5 = new Swiper(".swiper-container.swiper5", swiper5Opts);

    let swiper6mOpts = {
        direction: "horizontal",
        lazy: true,
        preloadImages: true,
        observeParents: true,
        autoHeight: true,
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 2,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next.swiper6m",
            prevEl: ".swiper-button-prev.swiper6m",
        },
        scrollbar: {
            el: ".swiper-scrollbar.swiper6m",
            draggable: true,
        },
    };

    let swiper6m = new Swiper(".swiper-container.swiper6m", swiper6mOpts);

    let swiper7mOpts = {
        direction: "horizontal",
        lazy: true,
        preloadImages: true,
        observeParents: true,
        autoHeight: true,
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 1,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 2,
            },
            // when window width is >= 768px
            992: {
                slidesPerView: 3,
            },
        },
        navigation: {
            enabled: true,
            nextEl: ".swiper-button-next.swiper7mc",
            prevEl: ".swiper-button-prev.swiper7mc",
        },
        scrollbar: {
            el: ".swiper-scrollbar.swiper7mc",
            draggable: true,
        },
    };

    let swiper7m = new Swiper(".swiper-container.swiper7m", swiper7mOpts);

    let swiper8mOpts = {
        direction: "horizontal",
        lazy: true,
        preloadImages: true,
        observeParents: true,
        autoHeight: true,
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        breakpoints: {
            // when window width is >= 576px
            576: {
                slidesPerView: 1,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 2,
            },
            // when window width is >= 768px
            992: {
                slidesPerView: 3,
            },
        },
        navigation: {
            enabled: true,
            nextEl: ".swiper-button-next.swiper8mc",
            prevEl: ".swiper-button-prev.swiper8mc",
        },
        scrollbar: {
            el: ".swiper-scrollbar.swiper8mc",
            draggable: true,
        },
    };
    let swiper8m = new Swiper(".swiper-container.swiper8m", swiper8mOpts);

    $(".swiper2px").each(function (index) {
        let idswiper = $(this).data("id");
        let swiper2pxOpts = {
            direction: "horizontal",
            lazy: true,
            preloadImages: true,
            autoHeight: true,
            loop: false,
            freeMode: false,
            slidesPerView: 1,
            navigation: {
                nextEl: `.swiper-button-next.${idswiper}`,
                prevEl: `.swiper-button-prev.${idswiper}`,
            },
            scrollbar: {
                el: `.swiper-scrollbar.${idswiper}`,
                draggable: true,
            },
        };
        let swiper2px = new Swiper(
            `.swiper-container.${idswiper}`,
            swiper2pxOpts
        );
    });
});

export { swiper as default };
